import React from 'react';
import { Alert, Box, Card, CardContent, Chip, Stack, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';

const TYPE_LABELS = {
  anlegen: 'Uebung anlegen',
  teilnehmer: 'Teilnehmer nachtragen',
  stadtgebiet: 'Stadtgebiet Duesseldorf',
  oeffentlichkeit: 'Oeffentlichkeitswirksam',
};

function UebungsplanungPage() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const type = (params.get('type') || '').toLowerCase();
  const selectedLabel = TYPE_LABELS[type] || 'Uebungsplanung';

  return (
    <Box sx={{ px: { xs: 1, sm: 3 }, py: 2 }}>
      <Stack spacing={2}>
        <Box>
          <Typography variant="h4" sx={{ fontWeight: 700 }}>
            Uebungsplanung
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Route und Berechtigungsmodell sind aktiv. Detailfunktionen koennen hier schrittweise aufgebaut werden.
          </Typography>
        </Box>

        <Card>
          <CardContent>
            <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                Auswahl
              </Typography>
              <Chip size="small" color="primary" label={selectedLabel} />
            </Stack>
            <Alert severity="info">
              Diese Seite ist als Ziel fuer die Dashboard-Kachel eingebunden und verhindert Fallback-Navigation.
            </Alert>
          </CardContent>
        </Card>
      </Stack>
    </Box>
  );
}

export default UebungsplanungPage;
